import { fetchJSON, fetchPOST } from "../Tools";

interface ITalsperreData {
    page: number;
    stationId: string;
    pegelId: string;
    threshold: number;
    description: string;
}

interface IDialogFields {
    pegelId: JQuery<HTMLElement>;
    threshold: JQuery<HTMLElement>,
    description: HTMLElement;
}

declare global {
    interface Window {
        evTalsperreChange: any;
        registerPegelDropDown: any;
    }
}
export default class TalsperreControl {

    protected container: HTMLElement;
    protected description: HTMLElement;
    protected currentDescription: string;
    protected dialog: JQuery<HTMLElement>;
    protected talsperreId: string;
    protected pegelId: string;
    protected dialogFields: IDialogFields;
    protected dialogSave: boolean = true;
    protected dialogChanged: boolean = false;
    protected trendIcons: NodeListOf<HTMLElement>;
    protected btnUpdate: HTMLButtonElement;

    constructor(container: HTMLElement) {
        this.container = container;
        if (this.container.classList.contains('js-talsperre-user-control')) {
            this.initFrontend();
            return;
        }
        if (!this.container.querySelectorAll(".js-talsperre-dialog-container").length) {
            return;
        }

        this.talsperreId = container.dataset.fkid;
        this.initDialog();

        window.evTalsperreChange = (item: JQuery<HTMLElement>) => {
            this.talsperreId = item.find(":selected").data().id;
            this.dialogChanged = true;
        }
    }

    initFrontend() {
        this.btnUpdate = <HTMLButtonElement>this.container.querySelector('button.js-btn-update');
        this.trendIcons = <NodeListOf<HTMLElement>>this.container.querySelectorAll('.pegel-current');
        this.description = <HTMLElement>this.container.querySelector('.js-description .ckedit');
        this.currentDescription = this.description.innerHTML;
        document.addEventListener('ckeditor:initDone', (ev: CustomEvent) => {
            if (ev.detail.ckeditorId === this.description.id) {
                this.description.addEventListener('input', () => {
                    if (this.currentDescription !== this.description.innerHTML) {
                        this.btnUpdate.disabled = false;
                    }
                    // console.log(ev.detail);
                });
                // this.parseDynText();
            }
        });
        this.trendIcons.forEach(trendButton => {
            trendButton.addEventListener('click', () => {
                if (trendButton.classList.contains('active')) {
                    return;
                }
                this.trendIcons.forEach(btn => {
                    btn.classList.remove('active');
                });
                this.btnUpdate.disabled = false;
                trendButton.classList.add('active');
            });
        });
        this.talsperreId = this.container.dataset.fkid;
        this.pegelId = this.container.dataset.pegelId;
        this.dialogSave = false;
        this.initDialog();
        window.registerPegelDropDown(this.dialog.find('.pegel-dropdown'));
        const _this = this;
        this.btnUpdate.addEventListener('click', async () => {
            const dlg = $('<div id="dialog-confirm" title="Talsperrensteuerung"><p><span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 20px 0;"></span>Sicher das die Daten gespeichert werden sollen?</p></div>');
            dlg.dialog({
                resizable: false,
                height: 180,
                modal: true,
                buttons: {
                    "Speichern": function () {
                        _this.userSave();
                        $(this).dialog("close");
                    },
                    "Abbrechen": function () {
                        $(this).dialog("close");
                    }
                }
            });

        });
        const nextUserControlContainer = this.container.parentElement.parentElement.nextElementSibling.querySelector('.js-talsperre-user-control');
        if (nextUserControlContainer) {
            this.container.parentElement?.classList.add('low-distance');
        }
    }

    parseDynText() {
        (<NodeListOf<HTMLElement>>this.description.querySelectorAll('.dynText')).forEach( async (dynTexElement) => {
            var data = JSON.parse(dynTexElement.dataset.json);
            const r = await fetchPOST('/Handler/HvD/TextMarker', {
                    extra: data.extra,
                    pid: data.pid,
                    type: data.type,
                    action: 'value',
            });
            this.refreshDynText(r, dynTexElement, data.type);
        });
    }


    refreshDynText (data: IDictionary, dynTexElement: HTMLElement, type: string) {
        var dd = new Date(data.eventDate);
        dynTexElement.title = data.stationName + ' [' + data.parameterId + '] vom ' + dd.toLocaleDateString() + ' ' + dd.toLocaleTimeString();
        dynTexElement.outerHTML =  parseFloat(data.eventValue).toFixed(2) + ' ' + data.units;
    }

    async userSave() {
        let trend = 0;
        this.trendIcons.forEach((trendButton, index) => {
            if (trendButton.classList.contains('active')) {
                trend = index - 1;
            }
        });
        let description = this.description.innerHTML;
        description = description.replace(/(\<span class="dynDrain">)(.[^<]+)(<\/span>)/, "$1[Abgabe]$3");
        let itemData: ITalsperreData = {
            page: parseInt(this.container.dataset.id),
            stationId: this.talsperreId,
            pegelId: this.pegelId,
            threshold: trend,
            description: description
        };

        const result = await fetchPOST('/?ajax=TalsperreControl&action=update&id=' + this.talsperreId + '-T', { data: JSON.stringify(itemData) }, false);
        if (result === 'OK') {
            this.btnUpdate.disabled = true;
            window.tools.toast('Talsperrensteuerung', 'Daten gespeichert');
            const r = await fetchPOST('/?ajax=TalsperreControl&action=parse&id=' + this.talsperreId + '-T', { data: JSON.stringify(itemData) }, false);


            let trendClass = trend === -1 ? 'trend-down' : trend === 0 ? 'trend-flat' : 'trend-up';
            document.querySelectorAll('.js-talsperre-info-control[data-fkid="' + this.talsperreId + '"]').forEach(el => {
                const currentTrend = el.querySelector('.pegel-current');
                currentTrend.className = 'pegel-current icon-trend ' + trendClass;
                if (el.querySelector('.detail-warn-info div.col-xs-11')) {
                    el.querySelector('.detail-warn-info div.col-xs-11').innerHTML = this.description.innerHTML;
                }
                el.querySelectorAll('.js-description').forEach( targetEl => {
                    // console.log(r);
                    targetEl.innerHTML = r;
                });

            });
        }

    }

    initDialog() {
        this.dialog = $(this.container.querySelector(".js-talsperre-dialog-container")).dialog({
            autoOpen: false,
            modal: true,
            width: 740,
            title: "Talsperrensteuerung",
            height: 500,
            maxHeight: 540
        });
        this.dialogFields = {
            pegelId: this.dialog.find('[name="talsperre-info-pegel"]'),
            threshold: this.dialog.find('[name="threshold"]'),
            description: this.dialog.find('.ckedit')[0]
        };
        this.container.querySelector('.js-edit-talsperre-dialog').addEventListener('click', () => {
            this.openDialog();
        });

        this.dialog.find('.js-btn-cancel')[0].addEventListener('click', async () => {
            this.dialog.dialog('close');
        });
        const _this = this;
        this.dialog.find('.drpTextbausteine').selectmenu({
            change: async function (event, ui) {
                if ((<any>ui.item).value === '') {
                    _this.dialogFields.description.innerHTML = '';
                    return;
                }
                let blockData = {
                    data: {
                        type: 'get',
                        id: <number>(<any>ui.item).value,
                    }
                };
                const result = await fetchPOST('/Handler/HvD/Textblock', blockData.data, false);
                _this.dialogFields.description.innerHTML = result;
            }
        });
        if (this.dialogSave) {
            this.dialog.find('.js-btn-save')[0].addEventListener('click', async () => {
                let itemData: ITalsperreData = {
                    page: -1,
                    stationId: this.talsperreId,
                    pegelId: this.dialogFields.pegelId.find(':selected').data().id,
                    threshold: parseInt(<string>this.dialogFields.threshold.val()),
                    description: this.dialogFields.description.innerHTML
                };

                const result = await fetchPOST('/?ajax=TalsperreControl&action=update&id=' + this.talsperreId + '-T', { data: JSON.stringify(itemData) }, false);
                if (result === 'OK') {
                    window.tools.toast('Talsperrensteuerung', 'Daten gespeichert');
                    this.dialog.dialog('close');
                }

            });
        } else {
            const btnUpdate = <HTMLButtonElement>this.dialog.find('.js-btn-save')[0];
            btnUpdate.innerText = 'Anwenden';
            btnUpdate.title = 'Änderungen im Frontend anwenden, es wird nicht gespeichert';
            btnUpdate.addEventListener('click', async () => {
                // Daten im frontend anzeigen
                if (this.pegelId !== this.dialogFields.pegelId.find(':selected').data().id) {
                    this.dialogChanged = true;
                    this.pegelId = this.dialogFields.pegelId.find(':selected').data().id;
                }
                if (!this.trendIcons[(<HTMLSelectElement>this.dialogFields.threshold[0]).selectedIndex].classList.contains('active')) {
                    this.dialogChanged = true;
                    this.trendIcons[(<HTMLSelectElement>this.dialogFields.threshold[0]).selectedIndex].dispatchEvent(new Event('click'));
                }
                if (this.dialogChanged || this.description.innerHTML !== this.dialogFields.description.innerHTML) {
                    let itemData: ITalsperreData = {
                        page: -1,
                        stationId: this.talsperreId,
                        pegelId: this.pegelId,
                        threshold: parseInt(<string>this.dialogFields.threshold.val()),
                        description: this.dialogFields.description.innerHTML
                    };
                    const result = await fetchPOST('/?ajax=TalsperreControl&action=parse&id=' + this.talsperreId + '-T', { data: JSON.stringify(itemData) }, false);
                    if (this.container.querySelector('.js-description .ckedit').innerHTML !== result) {
                        this.btnUpdate.disabled = false;
                        this.dialogChanged = true;
                        this.container.querySelector('.js-description .ckedit').innerHTML = result;
                    }
                }




                this.dialog.dialog('close');
            });
        }
    }

    async openDialog() {
        // Daten holen und dialogfelder setzen
        if (!this.dialogSave && this.dialogChanged) {
            this.dialog.dialog("open");
            return;
        }
        const result = await fetchJSON('/?ajax=TalsperreControl&id=' + this.talsperreId + '-T');
        if (result.length) {
            this.dialogFields.description.innerHTML = result[0].description;
            this.dialogFields.description.dispatchEvent(new Event('change'));
            this.dialogFields.threshold.val(result[0].threshold);
            this.dialogFields.pegelId.find('[data-id="' + result[0].pegelId + '"]').prop('selected', true);
            this.dialog.find('.pegel-dropdown').selectmenu('refresh');
        } else {
            this.dialogFields.description.innerHTML = '';
            this.dialogFields.description.dispatchEvent(new Event('change'));
            this.dialogFields.threshold.val('-1');
            this.dialogFields.pegelId.find('[data-id="none"]').prop('selected', true);
            this.dialog.find('.pegel-dropdown').selectmenu('refresh');
        }
        this.dialog.find('[data-name="station_id"]').val(this.talsperreId);
        this.dialog.show();
        this.dialog.dialog("open");
        this.dialog.find('.ui-widget').width('99%');

    }
}
